import React from "react";
import RelatedArticles from "@/components/ArticlePage/Components/RelatedArticles";
import { ArticlesByTag } from "@/components/PagePiller/api/interface";
import { DeviceInfo } from "@/interface/deviceInfo";
import { RegisterRefType } from "@/components/PageHome/interfaces";
import { FILTER_MAPPING } from "@/helpers/constants";
import { getResourceListingURL } from "@/helpers";
import styles from "./ArticlesByTag.module.scss";

interface ArticlesByTagComponentProps {
  data: ArticlesByTag;
  userAgent: DeviceInfo;
  registerRef?: RegisterRefType;
  assetPosition?: number;
  pillarSlug?: string;
  isPharma?: boolean;
}

const ArticlesByTagComponent: React.FC<ArticlesByTagComponentProps> = ({
  data,
  userAgent,
  registerRef,
  assetPosition,
  pillarSlug,
  isPharma = false,
}) => {  
  const { Title: title, ArticlesList, Tag } = data;
  const items = ArticlesList?.length > 0 ? ArticlesList : [];
  const tagSlug = Tag?.data?.attributes?.Slug;
  const { isMobile } = userAgent;

  const getCTAUrl: () => string = () => {
    return getResourceListingURL(
      {
        [FILTER_MAPPING.pillar]: [pillarSlug],
        [FILTER_MAPPING.tag]: [tagSlug],
      },
      "articles"
    );
  };

  return (
    <section
      data-ref_id={data?.refId}
      ref={(el) => {
        if (data?.ShowHeadingInIndex && registerRef && data?.refId) registerRef(data?.refId, el);
      }}
      className={`container ${styles.container} scrollMargin spacingBetweenSections`}
    >
      <RelatedArticles
        isPharma={isPharma}
        items={items}
        title={title}
        tags={[Tag]}
        ctaText={isMobile ? "Read more articles" : "View all articles"}
        ctaURL={getCTAUrl()}
        isCtaLink={isMobile}
        userAgent={userAgent}
        assetPosition={assetPosition}
      />
    </section>
  );
};

export default ArticlesByTagComponent;
